/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A named person at a carrier, for the Contacts tab.
 * @export
 * @interface CarrierContactSummary
 */
export interface CarrierContactSummary {
  /**
   *
   * @type {string}
   * @memberof CarrierContactSummary
   */
  carrierContactId: string;
  /**
   *
   * @type {string}
   * @memberof CarrierContactSummary
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CarrierContactSummary
   */
  title?: string | null;
  /**
   *
   * @type {string}
   * @memberof CarrierContactSummary
   */
  role?: string | null;
  /**
   *
   * @type {string}
   * @memberof CarrierContactSummary
   */
  seniority?: string | null;
  /**
   *
   * @type {string}
   * @memberof CarrierContactSummary
   */
  email?: string | null;
  /**
   *
   * @type {string}
   * @memberof CarrierContactSummary
   */
  phone?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CarrierContactSummary
   */
  isCurrent: boolean;
  /**
   *
   * @type {string}
   * @memberof CarrierContactSummary
   */
  departedNote?: string | null;
  /**
   *
   * @type {string}
   * @memberof CarrierContactSummary
   */
  notes?: string | null;
}

/**
 * Check if a given object implements the CarrierContactSummary interface.
 */
export function instanceOfCarrierContactSummary(
  value: object,
): value is CarrierContactSummary {
  if (!("carrierContactId" in value) || value["carrierContactId"] === undefined)
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("isCurrent" in value) || value["isCurrent"] === undefined) return false;
  return true;
}

export function CarrierContactSummaryFromJSON(
  json: any,
): CarrierContactSummary {
  return CarrierContactSummaryFromJSONTyped(json, false);
}

export function CarrierContactSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierContactSummary {
  if (json == null) {
    return json;
  }
  return {
    carrierContactId: json["carrierContactId"],
    name: json["name"],
    title: json["title"] == null ? undefined : json["title"],
    role: json["role"] == null ? undefined : json["role"],
    seniority: json["seniority"] == null ? undefined : json["seniority"],
    email: json["email"] == null ? undefined : json["email"],
    phone: json["phone"] == null ? undefined : json["phone"],
    isCurrent: json["isCurrent"],
    departedNote:
      json["departedNote"] == null ? undefined : json["departedNote"],
    notes: json["notes"] == null ? undefined : json["notes"],
  };
}

export function CarrierContactSummaryToJSON(json: any): CarrierContactSummary {
  return CarrierContactSummaryToJSONTyped(json, false);
}

export function CarrierContactSummaryToJSONTyped(
  value?: CarrierContactSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierContactId: value["carrierContactId"],
    name: value["name"],
    title: value["title"],
    role: value["role"],
    seniority: value["seniority"],
    email: value["email"],
    phone: value["phone"],
    isCurrent: value["isCurrent"],
    departedNote: value["departedNote"],
    notes: value["notes"],
  };
}
